export enum LoadingActionTypes {
  SET_IS_LOADING_DATA = 'SET_IS_LOADING_DATA',
  SET_IS_NOT_LOADING_DATA = 'SET_IS_NOT_LOADING_DATA',
}

export interface ILoadingState {
  loading: boolean;
}
